import { PrimaryLoadingIndicator } from "./PrimaryLoadingIndicator.tsx";
import { LoaderSize } from "./LoaderSize.tsx";

export function CenteredLoading() {
  return (
    <div className={"flex justify-center"}>
      <PrimaryLoadingIndicator size={LoaderSize.Large} />
    </div>
  );
}
